/**
 * Purpose: This code encrypts a subscription password using crypto encryption.
 * It takes 'subscriptionPassword' from 'window.subscriptionPassword.subscription_Key', 
 */


var subscriptionPassword = window.pepperboxPasswod.password;
var md5Pass = null;

if (subscriptionPassword !== null) {
 
  const wordArray = CryptoJS.enc.Utf8.parse(subscriptionPassword);
  const md5Hash = CryptoJS.MD5(wordArray);
  md5Pass = md5Hash.toString(CryptoJS.enc.Hex);
  const preventDevMenu = () => {
    window.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    document.onkeydown = (e) => {
      if (
        e.key === 'F12' ||
        e.key === 'Shift' ||
        e.key === 'Meta' ||
        e.key === 'Alt' ||
        e.key === 'Control'
      ) {
        return false; 
      }
    };
  };

/**
 * Show Overlay
 */
showOverlay=()=>{
  document.getElementById('site-overlay').classList.add('overlay--body');
  document.querySelector('body').classList.add('scroll-fixed');
}
 /**
   * Hide Overlay
   */
  hideOverlay=()=>{
    document.getElementById('site-overlay')?.classList.remove('overlay--body');
  }
  showOverlay();
  preventDevMenu();
}

const passwordModal=document.querySelector('#texas-password-modal')
var texasLogin = sessionStorage.getItem('texas_login');
if (texasLogin == "true") {
  texasLogin = true;
}else{
  texasLogin = false;
}
if (!texasLogin) {
  passwordModal.querySelector('form').addEventListener('submit',(event)=>{
    event.preventDefault();
    let passWord=passwordModal.querySelector('input[name="password"]').value;
  
    
    const wordArray = CryptoJS.enc.Utf8.parse(passWord);
  
    // Calculate the MD5 hash
    const md5Hash = CryptoJS.MD5(wordArray);
  
    // Convert the MD5 hash to a hexadecimal string
    const encryptedPassword = md5Hash.toString(CryptoJS.enc.Hex);
  
    if (md5Pass == encryptedPassword) {
      document.querySelectorAll('.shopify-section').forEach((ele)=>{
        ele.style.display="block";
      })
      passwordModal.style.display="none";
      hideOverlay();
      document.querySelector('body')?.classList.remove('scroll-fixed');
      sessionStorage.setItem('texas_login', true);
    }else{
      if(passwordModal.querySelector('.error-text') != null)
        { passwordModal.querySelector('.error-text').style.display="block" }
      }
  })
}else{
  passwordModal.style.display="none";
  hideOverlay();
  document.querySelector('body')?.classList.remove('scroll-fixed');
  document.querySelectorAll('.shopify-section').forEach((ele)=>{
    ele.style.display="block";
  })
}